module.exports = __webpack_public_path__ + "assets/img/ProspectusBAPC.c360947f.png";